import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../contexts/UserContext';
import { useNavigate, useParams } from 'react-router-dom';
import { providersPathTo } from '../utils/Api';
import SnackbarContext from '../contexts/SnackbarContext';
import TagList from './TagList';
import { Avatar, Box, Button, Divider, Typography } from '@mui/material';
import ProductPhotoPlaceholder from '../images/placeholder_product_image.png';
import { apiBaseUrl } from '../utils/Api/Api';
import ProviderCard from './building_blocks/ProviderCard';
import { currency } from './building_blocks/Currency';
import { ShoppingCartProductsContext } from '../contexts/ShoppingCartProductsContext';
import ProductsTagFilters from './ProductsTagFilters';

function ProviderShop() {
  const { id } = useParams();
  const [provider, setProvider] = useState();
  const [tagFilter, setTagFilter] = useState([]);
  const { shoppingCartProducts, setShoppingCartProducts } = useContext(ShoppingCartProductsContext);
  const navigate = useNavigate();
  const { openSnackbar } = useContext(SnackbarContext);

  const handleAddProduct = (product, index) => {
    if (shoppingCartProducts.length > 0 && shoppingCartProducts[0].provider_id !== product.provider_id) {
      openSnackbar('Você não pode adicionar produtos de lojas diferentes ao carrinho', 'info');
      return;
    }
    const newCartProduct = {
      ...product,
      cartQuantity: 1,
      productIndex: index
    };
    setShoppingCartProducts([...shoppingCartProducts, newCartProduct]);
    localStorage.setItem('shoppingCartProducts', JSON.stringify([...shoppingCartProducts, newCartProduct]));
    localStorage.setItem('shoppingProvider', JSON.stringify(provider));
  };

  const changeCartQuantity = (id, operation) => {
    let newShoppingCartProducts = [...shoppingCartProducts];
    const cartProduct = shoppingCartProducts.find(product => product.id === id);
    if (operation === '+') {
      if (cartProduct.quantity === 0 || (cartProduct.cartQuantity < cartProduct.quantity))
        cartProduct.cartQuantity += 1;
    } else {
      cartProduct.cartQuantity -= 1;
    }
    if (cartProduct.cartQuantity < 1) {
      var index = newShoppingCartProducts.findIndex(item => item.id === id);
      newShoppingCartProducts.splice(index, 1);
    }
    setShoppingCartProducts(newShoppingCartProducts);
    localStorage.setItem('shoppingCartProducts', JSON.stringify(newShoppingCartProducts));
  };

  useEffect(() => {
    if (id) {
      providersPathTo.provider_with_products({id: id}).then(result => {
        setProvider(result.data);
      });
    }
  }, []);
  
  useEffect(() => {
    if (!provider) {
      return;
    }
    document.title = `${provider.name} - TudoPets.app`;
  }, [provider]);

  if (!provider) {
    return <div>Carregando...</div>;
  }

  const filteredProducts = provider.products.filter(product => tagFilter.length === 0 || tagFilter.every(selectedTag => product.tags.some(productTag => productTag.id === selectedTag.id)));

  return (
    <Box>
      {provider.business_banner && 
        <Box sx={{ width: "calc(100% + 32px)", margin: "-16px", marginBottom: "16px", height: "140px" }}>
          <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={`${apiBaseUrl}${provider.business_banner}`} />
        </Box>
      }
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
        <Box flexGrow={1} m={2} textAlign="left">
          <Typography variant="body1"><b>{provider.name}</b></Typography>
          <Typography fontSize={14} color="gray">
            <small>Entrega em até 24h &#9679; R$10,00</small>
          </Typography>
          <Typography color="primary" onClick={() => navigate('/shop_info/', {state: provider})} fontSize={14}><small>Perfil da loja</small></Typography>
        </Box>
        <Box mr={2}>
          <Avatar sx={{ border: '1px solid lightgray', marginLeft: 'auto', width: '60px', height: '60px' }} src={provider.business_logo && `${apiBaseUrl}${provider.business_logo}`} />
        </Box>
      </Box>
      <Divider><Typography color="primary"><b>Produtos</b></Typography></Divider>
      <ProductsTagFilters tagFilter={tagFilter} setTagFilter={setTagFilter} tags={provider.tags} numProducts={filteredProducts.length}/>
      {filteredProducts.map((product, index) => (
        <Box key={product.id}>
          <Box m={2} display="flex" sx={{ width: "100%", height: '110px' }}>
            <Box sx={{ width: "60%" }}>
              <Typography mr={2} textAlign="left" variant="body1"><b>{product.title}</b></Typography>
              <Typography mb={1} mr={2} textAlign="justify" sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: '2',
                WebkitBoxOrient: 'vertical',
                fontSize: '13px',
              }} color="gray">
                {product.description}
              </Typography>
              <Typography variant="body1" textAlign="left"><b>{currency(product.price)}</b></Typography>
            </Box>
            <Box mb="1" sx={{ width: "30%", height: '110px', position: "relative" }}>
              {!shoppingCartProducts.find(item => item.id === product.id) &&
                <Button sx={{ position: 'absolute', bottom: 0, right: 0, borderRadius: '8px', backgroundColor: 'white', minWidth: '35px', minHeight: '30px', "&.MuiButtonBase-root:hover": {
                  bgcolor: "white" }}} variant="outlined" onClick={() => handleAddProduct(product, index)}>+</Button>
              }
              {shoppingCartProducts.find(item => item.id === product.id) && 
                <Box sx={{ width: "100%", height: "25%", backgroundColor: 'white', position: 'absolute', bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Box><Button onClick={() => changeCartQuantity(product.id, '-')}><Typography variant="h5" color="primary">-</Typography></Button></Box>
                  
                  <Box><Typography variant="body1">{shoppingCartProducts.find(item => item.productIndex === index).cartQuantity}</Typography></Box>

                  <Box>
                    <Button
                      onClick={() => changeCartQuantity(product.id, '+')}
                      disabled={product.quantity > 0 && (shoppingCartProducts.find(item => item.productIndex === index).cartQuantity >= product.quantity)}
                    >
                      <Typography
                        variant="h5"
                        color={
                          product.quantity > 0 && (shoppingCartProducts.find(item => item.productIndex === index).cartQuantity >= product.quantity) ?
                            "gray" :
                            "primary"
                        }
                      >
                        +
                      </Typography>
                    </Button>
                  </Box>
                </Box>
              }
              <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={product.item_photo ? `${apiBaseUrl}${product.item_photo}` : ProductPhotoPlaceholder} />
            </Box>
          </Box>
          {provider.products.length !== index + 1 && (
            <Divider variant="middle"/>
          )}
        </Box>
      ))}
    </Box>
  );
}

export default ProviderShop;

